module.exports = __webpack_public_path__ + "static/media/star-solid.34bfb7fe.svg";